import { OnboardingTemplate } from '../../common/experiments/inline-onboarding/template';
import { updateExistingPageWithInlineOnboardingTemplate } from '../../common/experiments/inline-onboarding/util';
import { type ConfluenceBlueprintPage } from '../../state/confluence/types';
import { fetchJson } from '../utils';

export const IGNORE_MAU_HEADER = 'x-atlassian-mau-ignore';
export const EP_ENITITY_ID_HEADER = 'X-Atl-EmbeddablePage-EntityIDs';

export const createConfluenceDraft = async ({
	templateId,
	projectSpaceKey,
	projectPageLinkedId,
	isEmbeddedPage,
	pageTitle,
	projectId,
	projectType,
	initialContent,
}: {
	templateId: string;
	projectSpaceKey: string;
	projectPageLinkedId: string | null;
	isEmbeddedPage: boolean;
	pageTitle?: string;
	projectId?: number;
	projectType?: string;
	initialContent?: OnboardingTemplate;
}) => {
	const requestBody = {
		content: {
			type: 'page',
			status: 'draft',
			space: { key: projectSpaceKey },
			...(projectPageLinkedId && {
				ancestors: [{ id: projectPageLinkedId }],
			}),
			title: pageTitle,
			...(isEmbeddedPage && {
				metadata: {
					frontend: {
						embedded: true,
					},
				},
			}),
		},
		contentBlueprintSpec: {
			context: {},
			blueprintId: templateId,
		},
	};
	// First create the blueprint page
	const response = await fetchJson<ConfluenceBlueprintPage>(
		`/wiki/rest/create-dialog/1.0/content/blueprint/${templateId}/instance`,
		{
			method: 'POST',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
				[IGNORE_MAU_HEADER]: 'true',
				[EP_ENITITY_ID_HEADER]: JSON.stringify({
					projectId,
					projectType,
				}),
			},
			body: JSON.stringify(requestBody),
		},
	);

	// If we have initial content, update the page with it
	if (initialContent && response.content.id) {
		updateExistingPageWithInlineOnboardingTemplate({
			pageId: response.content.id,
			template: initialContent,
			projectId,
			projectType,
			pageTitle,
		});
	}

	return response;
};
